/**
 * ReplyAllIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ReplyAllIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m6.936 15.893-4.652-4.629a1 1 0 0 1-.216-.314.9.9 0 0 1-.068-.352q0-.184.068-.352a1 1 0 0 1 .216-.315L6.95 5.265A.92.92 0 0 1 7.616 5a.92.92 0 0 1 .69.279q.27.283.27.678t-.283.678l-3.962 3.963 3.976 3.976q.273.273.271.654a.92.92 0 0 1-.285.665.93.93 0 0 1-.678.283.93.93 0 0 1-.679-.283m14.114 2.706a.92.92 0 0 1-.678-.272.92.92 0 0 1-.272-.678v-3.022q0-1.358-.867-2.219-.868-.86-2.212-.86h-6.773l3.026 3.026q.273.273.26.654a.96.96 0 0 1-.297.665.93.93 0 0 1-.679.283.88.88 0 0 1-.664-.283l-4.63-4.629a1 1 0 0 1-.214-.314.9.9 0 0 1-.069-.352q0-.184.069-.352a1 1 0 0 1 .215-.315l4.653-4.666A.92.92 0 0 1 12.584 5a.92.92 0 0 1 .69.279q.27.283.27.678t-.283.678l-3.013 3.013h6.773q2.12 0 3.55 1.43 1.428 1.429 1.429 3.549v3.022a.92.92 0 0 1-.272.678.92.92 0 0 1-.678.272" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ReplyAllIcon = makeIcon('ReplyAllIcon', ReplyAllIconSvg)
